import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useCurrencyService from '../../../app/services/hooks/useCurrencyService';
import { Currency } from '../../../app/models/Currency';
import CurrencyFormContainer from './CurrencyFormContainer';

interface Props {
    currencyId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const CurrencyEdit = ({ currencyId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditCurrency, editCurrency, fetchingUpdateCurrency, updateCurrency } =
        useCurrencyService();

    const [currency, setCurrency] = useState<Currency>({ name: '', iso_code: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando moneda...');
        editCurrency(currencyId, {
            onSuccess: (response: ServiceResponse) => {
                setCurrency(response.data.currency);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando moneda...');
        updateCurrency(currencyId, currency, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditCurrency ? (
        <LazyLoading height="300" />
    ) : (
        <CurrencyFormContainer
            fetching={fetchingUpdateCurrency}
            action={update}
            cancel={cancel}
            currency={currency}
            setCurrency={setCurrency}
            errorFields={errorFields}
        />
    );
};

export default CurrencyEdit;
